import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './guard/auth.guard';

const routes: Routes = [
  {
    path: '',
    title: 'Accueil',
    loadChildren: () =>
      import('./welcome/welcome.module').then(m => m.WelcomeModule),
  },
  {
    path: 'restaurant',
    title: 'Notre Restaurant',
    loadChildren: () =>
      import('./restaurant/restaurant.module').then(m => m.RestaurantModule),
  },
  {
    path: 'cgv',
    title: 'Conditions Générales',
    loadChildren: () =>
      import('./cgb/cgb.module').then(m => m.CgbModule)
  },
  {
    path: 'mentions-legal',
    title: 'Mentions Légales',
    loadChildren: () =>
      import('./mentions-legal/mentions-legal.module').then(m => m.MentionsLegalModule)
  },
  {
    path: 'allergene',
    title: 'Allergènes',
    loadChildren: () =>
      import('./allergene/allergene.module').then(m => m.AllergeneModule)
  },
  {
    path: 'order',
    title: 'Commander',
    loadChildren: () =>
      import('./order/order.module').then(m => m.OrderModule),
  },
  {
    path: 'product',
    title: 'Nos Produits',
    loadChildren: () =>
      import('./product/product.module').then(m => m.ProductModule),
  },
  {
    path: 'login',
    title: 'Connexion',
    loadChildren: () =>
      import('./login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'profil',
    title: 'Mon Profil',
    loadChildren: () =>
      import('./profil/profil.module').then(m => m.ProfilModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'command',
    title: 'Mes Commandes',
    loadChildren: () =>
      import('./command/command.module').then(m => m.CommandModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'error-404',
    title: 'Page Introuvable',
    loadChildren: () => import('./error/error.module').then(m => m.ErrorModule)
  },
  {
    path: '**',
    redirectTo: 'error-404'
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled', // Changé de 'top' à 'enabled'
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'reload' // AJOUT IMPORTANT
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
